import { useState } from 'react';
import AppPayment from './AppPayment';
import AppPaymentUI2 from './AppPaymnet_1';
import GasystemExternalManualPayment from '../../App/Pages/GasystemExternalManualPayment';
import useManualPaymentConfig from '../../Common/hooks/useManualPaymentConfig';
import { BRAND_COPYRIGHT } from '../../Common/config/brandConfig';
import {
    searchGasystemCpPaymentCustomers,
    submitGasystemCpManualPayment,
} from '../api/gasystemManualPayment';

const GASYSTEM_CP_DELEGATED_PAYMENT_ENABLED = ['1', 'true', 'yes', 'y'].includes(
    String(process.env.REACT_APP_GASYSTEM_CP_DELEGATED_PAYMENT_ENABLED || '').trim().toLowerCase(),
);

function AppPaymentPage() {
    const [uiMode, setUiMode] = useState('A');
    const manualPaymentConfig = useManualPaymentConfig('cp');
    const isGasystemDelegatedMode = GASYSTEM_CP_DELEGATED_PAYMENT_ENABLED;

    return (
        <div style={{
            flex: 1,
            minHeight: 0,
            height: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '768px',
            margin: '0 auto',
            background: '#FFFFFF',
            overflow: 'hidden',
            boxSizing: 'border-box',
        }}>
            <div style={{
                background: 'linear-gradient(160deg, var(--brand-gradient-start) 0%, var(--brand-gradient-mid) 60%, var(--brand-gradient-end) 100%)',
                height: '62px',
                padding: '0 12px 0 10px',
                color: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                flexShrink: 0,
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 2px',
                    position: 'relative',
                    width: '100%',
                }}>
                    <div style={{ width: '28px', height: '28px', flexShrink: 0 }} />
                    <h1 style={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: '16px',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        margin: 0,
                    }}>
                        {isGasystemDelegatedMode ? '대리 수기결제' : '수기결제'}
                    </h1>
                    {isGasystemDelegatedMode ? (
                        <div aria-hidden="true" style={{ width: 28, height: 28, flexShrink: 0 }} />
                    ) : (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0,
                            background: 'rgba(255,255,255,0.25)',
                            borderRadius: '10px',
                            padding: '3px',
                            border: '1px solid rgba(255,255,255,0.4)',
                            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
                        }}>
                            {['A', 'B'].map((mode) => (
                                <button
                                    key={mode}
                                    type="button"
                                    onClick={() => setUiMode(mode)}
                                    style={{
                                        padding: '3px 10px',
                                        fontSize: uiMode === mode ? '15px' : '13px',
                                        fontWeight: 700,
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        background: uiMode === mode ? '#FFFFFF' : 'transparent',
                                        color: uiMode === mode ? 'var(--brand-gradient-mid)' : 'rgba(255,255,255,0.7)',
                                        boxShadow: uiMode === mode ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
                                    }}
                                >
                                    {mode}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                {isGasystemDelegatedMode ? (
                    <GasystemExternalManualPayment
                        config={manualPaymentConfig}
                        customerSearch={searchGasystemCpPaymentCustomers}
                        submitPayment={submitGasystemCpManualPayment}
                        loginPath="/cp/login"
                        delegatedPayment
                    />
                ) : (
                    <>
                        {uiMode === 'A' && <AppPaymentUI2 hideHeader />}
                        {uiMode === 'B' && <AppPayment hideHeader />}
                    </>
                )}
            </div>

            <footer style={{
                flexShrink: 0,
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
                textAlign: 'center',
                fontSize: '12px',
                color: '#8b95a1',
                borderTop: '1px solid #f2f4f6',
            }}>
                {BRAND_COPYRIGHT}
            </footer>
        </div>
    );
}

export default AppPaymentPage;
